// extracted by mini-css-extract-plugin
module.exports = {"field":"MetricField-field-3zy1HF","label":"MetricField-label-3qCNg1","value":"MetricField-value-3psGBO"};